import React, {Component}         from 'react';
import { connect }                from 'react-redux';
import {Field, reduxForm, reset}  from 'redux-form';
import validate                   from '../../../service/validate_nave';
import renderField                from '../../../container/renderField';
import { SetComentarioPost, 
         GetQtdCommentPostTurma, 
         GetComentariosPostTurma } from '../../../actions/turmaAction';

class Turma_Post_Form_Comentario extends Component {

    constructor(props){

        super(props);
        this.state = {
                        comentario : "",
                        publicText     : "a",
                        tur_pos_id     : this.props.tur_pos_id,
                        use_id         : this.props.use_id,
                        errors         : {}
                     }
   
    }

   handleSubmit(e){
      this.props.SetComentarioPost(this.state,e.comentario).then((response)=>{
          
      })
   }

   render() {

       const {handleSubmit} = this.props;   
        return (
            <div>               
                <form onSubmit={handleSubmit(this.handleSubmit.bind(this))}>
                    <div className="input-group">
                        <Field 
                            name        = "comentario"
                            type        = "text"
                            component   = {renderField}
                            placeholder = "Escreva um comentário..."
                            label       = ""
                        />     
                        <span className="input-group-btn">
                            <button
                                className = "btn btn-default"
                                type      = "submit"
                                onClick   = {this.setComentarioPost}>
                                <span className="glyphicon glyphicon-send" aria-hidden="true"></span>
                            </button>
                        </span>
                    </div>
                </form>
            </div>
        )
    }
}


const afterSubmit = (result, dispatch) => dispatch(reset('comentario_nave'));

export default reduxForm({
   form                     : 'comentario_nave', //                 <------ same form name
   destroyOnUnmount         : true, //        <------ preserve form data
   forceUnregisterOnUnmount : true, // <------ unregister fields on unmount
     onSubmitSuccess          : afterSubmit,
  validate
})(connect(null,{ SetComentarioPost, GetQtdCommentPostTurma, GetComentariosPostTurma})(Turma_Post_Form_Comentario));



// WEBPACK FOOTER //
// ./src/components/professor/timeline_turma/turma_post_form_comentario.js